export default "__VITE_ASSET__lN6VZb4q__"